<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <path
      :fill="color"
      d="M10.587 13.876L7.803 16.66c-1.785 1.786-4.677 1.787-6.463 0-1.786-1.785-1.787-4.677 0-6.463l2.784-2.784.124-.12c.265-.246.696-.07.71.291.007.17.021.338.043.506.017.13-.026.262-.12.355l-2.647 2.647c-1.291 1.292-1.29 3.381 0 4.674 1.293 1.291 3.382 1.29 4.674 0l2.784-2.785.013-.013c1.276-1.289 1.27-3.377-.013-4.66-.289-.29-.618-.513-.97-.672-.16-.073-.26-.235-.25-.41.01-.183.044-.363.099-.537.074-.232.335-.35.56-.256.53.222 1.026.55 1.456.98 1.782 1.782 1.782 4.681 0 6.463zm-3.174-3.289c.43.43.927.758 1.456.98.225.094.486-.024.56-.256.055-.174.089-.354.1-.536.01-.176-.09-.338-.251-.41-.352-.16-.681-.384-.97-.672-1.284-1.284-1.29-3.372-.013-4.662l.013-.012 2.784-2.785c1.292-1.29 3.381-1.291 4.674 0 1.29 1.293 1.291 3.382 0 4.674l-2.648 2.647c-.093.093-.136.224-.12.355.023.168.037.336.044.506.014.361.445.537.71.29.042-.038.084-.078.124-.119l2.784-2.784c1.787-1.786 1.786-4.678 0-6.463-1.786-1.787-4.678-1.786-6.463 0L7.413 4.124c-1.782 1.782-1.782 4.681 0 6.463z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
